import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/publishReplay';
import 'rxjs/add/operator/toPromise';
import { ConfigService } from '../providers/config';

@Injectable()
export class AppConfig {

    appInfo: any = {
        version: '1.0.2',
        name: 'regisafe WebClient'
    };
    config: any = {};
    cachedCategories: any;

    constructor(public http: Http,
                public configService: ConfigService) {
    }

    /**
     * Gets the categories from API
     * @returns {Observable<any>}
     */
    getCategories(): Observable<any> {
        let storedendpoint = JSON.parse(localStorage.getItem('appconfig'));

        this.config = this.configService.getConfig();
        let storedToken = localStorage.getItem('nodetoken');
        let headers = new Headers();
        headers.append('X-NODE-TOKEN', storedToken);

        return this.http.get(storedendpoint.apiendpoint + 'users/conditions', {headers: headers})
            .map(response => response.json())
            .do(response => this.cachedCategories = response);
    }

    /**
     * Gets the categories from API
     * @returns {Observable<any>}
     */
    getCachedCategories() {
        return this.cachedCategories;
    }

    /**
     * Returns app info object
     * @returns {any}
     */
    getAppInfo() {
        return this.appInfo;
    }
}




// WEBPACK FOOTER //
// ./src/shared/app.config.ts